export default __webpack_public_path__ + "static/media/meh-silver.31f2a903.svg";